import React from 'react';
import './position.css';
import NavBar from '../../componets/navbar/navbar.js';
import { Container, Row, Col } from 'react-bootstrap';
import { getPositionByKey } from '../../services/contentService';


class Position extends React.Component {
    
    constructor(props) {
        super(props);
        const { position } = this.props.match.params;
        this.state = { path: position, loading:true, position:{}};
        // To use the 'this' keyword, we need to bind it to our function
      }
      async componentDidMount(){
                    try {
                        const position = await getPositionByKey(this.state.path);
                        this.setState({loading:false, position: position || {}});
                    } catch (_) {
                        this.setState({loading:false, position:{}});
                    }
      }


      getloading(){
        return(
           <div className = 'loader-container'>
             <div className = 'spinner'></div>
           </div>
        );
       }


       getSuccess(){
        return (
        <div >
            <Container fluid>
            <Row>
            <Col xs={6} md={4} className = "position-details">
            <Row className = "position-title">
                {this.state.position.title}
            </Row>
            <Row className = "position-description">
                {this.state.position.description}
            </Row>
            </Col>
            <Col className = "position-image">
            <img className= "position-image-img" src={this.state.position.imageUrl} alt={this.state.position.title}/>
            </Col>
            </Row>

            </Container>
          </div>
          );
      }

    render () {
        // console.log(this.state)
        const response = this.state.loading?this.getloading():this.getSuccess();
        return (
            <div className='position'>
            <NavBar/>
            <div>{response}</div>
        
        </div>

      );
    }
}

export default (Position);